import { Divider, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { useEffect, useState } from "react";
import { BooleanField, Datagrid, DateField, ListContextProvider, Pagination, TextField, useList } from "react-admin";
import dataProvider from "../../../providers/data-provider";
import { DashboardButton } from "../../dashboard-button";

const TeacherDashboardProcesses = (props) => {

    const [page, setPage] = useState(1)
    const [data, setData] = useState([])
    const [total, setTotal] = useState(0)
    const [value, setValue] = useState('active');
    const [filter, setFilter] = useState({ active: true })
    const [loaded, setLoaded] = useState(false)
    const [loading, setLoading] = useState(true)
    const [perPage, setPerPage] = useState(10)

    useEffect(() => {
        (async () => {
            setLoading(true)
            setLoaded(false)
            const resp = await dataProvider.get('teacher', 'process-dashboard', { filter: JSON.stringify(filter), page, limit: perPage })
            setData(resp.data.data)
            setTotal(resp.data.total)
            setLoading(false)
            setLoaded(true)
        })()
    }, [filter, page, perPage])

    const ids = data.map((row) => row.id)
    const sort = { field: 'id', order: 'DESC' };
    const context = useList({ data, ids, loading, loaded, page, perPage, sort, filter })

    const handleChange = (event) => {
        let value = event.target.value;
        setValue(value);
        switch (value) {

            case 'all':
                setFilter({})
                break;

            case 'active':
            default:
                setFilter({ active: true })
                break;

            case 'finished':
                setFilter({ active: false })
                break;
        }
    }

    return (
        <>
            <FormControl style={{ marginBlock: '10px', marginInline: '10px', minWidth: '150px' }}>
                <InputLabel id={'filter-select-label'}>Filtro</InputLabel>
                <Select labelId={'filter-select-label'} id={'filter-select'} value={value} disabled={loading} onChange={handleChange} variant="filled">
                    <MenuItem value={'all'}> Todos </MenuItem>
                    <MenuItem value={'active'}>Em aberto</MenuItem>
                    <MenuItem value={'finished'}>Arquivados</MenuItem>
                </Select>
            </FormControl>

            <Divider />

            <ListContextProvider value={context}>
                <Datagrid loaded={context.loaded} basePath="/processes" resource="processes">
                    <TextField source="alias" label={'Protocolo'} />
                    <TextField source="client.name" label={'Cliente'} />
                    <DateField source="created_at" label={'Criado em'} locales={'pt-BR'} />
                    <BooleanField source="active" label={'Em aberto'} />
                    <TextField source="institution_branch.name" label={'Unidade'} />
                    <TextField source="institution_branch.institution.name" label={"Instituição"} />
                    <DashboardButton />
                </Datagrid>
                <Pagination total={total} page={page} setPage={setPage} setPerPage={setPerPage} perPage={perPage} rowsPerPageOptions={[5, 10, 25]} />
            </ListContextProvider>

        </>
    )
}




export default TeacherDashboardProcesses